var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 194,
    viewBox: "0 0 148 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.8607 172.244C113.737 172.244 146.062 140.074 146.062 100.39C146.062 60.7062 113.737 28.5361 73.8607 28.5361C33.9849 28.5361 1.65918 60.7062 1.65918 100.39C1.65918 140.074 33.9849 172.244 73.8607 172.244Z",
    fill: "url(#paint0_linear_12439_55183)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8607 172.244C113.737 172.244 146.062 140.074 146.062 100.39C146.062 60.7062 113.737 28.5361 73.8607 28.5361C33.9849 28.5361 1.65918 60.7062 1.65918 100.39C1.65918 140.074 33.9849 172.244 73.8607 172.244Z",
    fill: "#E4E4E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.403646,
    d: "M29.917 184.173C36.3431 184.173 41.5525 178.961 41.5525 172.533C41.5525 166.105 36.3431 160.894 29.917 160.894C23.4909 160.894 18.2815 166.105 18.2815 172.533C18.2815 178.961 23.4909 184.173 29.917 184.173Z",
    fill: "url(#paint1_linear_12439_55183)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12439_55183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8296 24.5449H109.078C115.286 24.5449 120.318 29.5789 120.318 35.7885V156.079C120.318 162.289 115.286 167.323 109.078 167.323H38.8296C32.6221 167.323 27.5898 162.289 27.5898 156.079V35.7885C27.5898 29.5789 32.6221 24.5449 38.8296 24.5449Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8296 24.5449H109.078C115.286 24.5449 120.318 29.5789 120.318 35.7885V156.079C120.318 162.289 115.286 167.323 109.078 167.323H38.8296C32.6221 167.323 27.5898 162.289 27.5898 156.079V35.7885C27.5898 29.5789 32.6221 24.5449 38.8296 24.5449Z",
    fill: "url(#paint2_linear_12439_55183)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.268 31.102C110.406 31.102 113.761 34.4579 113.761 38.5977V153.267C113.761 157.406 110.406 160.762 106.268 160.762H41.6394C37.501 160.762 34.1462 157.406 34.1462 153.267V38.5977C34.1462 34.4579 37.501 31.102 41.6394 31.102L53.5856 31.1016C53.5716 31.256 53.5645 31.4124 53.5645 31.5705C53.5645 34.4166 55.871 36.7238 58.7161 36.7238H90.1623C93.0074 36.7238 95.3139 34.4166 95.3139 31.5705C95.3139 31.4124 95.3067 31.256 95.2928 31.1016L106.268 31.102Z",
    fill: "url(#paint3_linear_12439_55183)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.168 150.385H40.7026C39.668 150.385 38.8293 151.224 38.8293 152.259C38.8293 153.294 39.668 154.133 40.7026 154.133H107.168C108.203 154.133 109.041 153.294 109.041 152.259C109.041 151.224 108.203 150.385 107.168 150.385Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.659 134.288H40.1939C39.1593 134.288 38.3206 135.127 38.3206 136.162C38.3206 137.197 39.1593 138.036 40.1939 138.036H106.659C107.694 138.036 108.533 137.197 108.533 136.162C108.533 135.127 107.694 134.288 106.659 134.288Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.899 142.336H40.4338C39.3992 142.336 38.5605 143.175 38.5605 144.21C38.5605 145.245 39.3992 146.084 40.4338 146.084H106.899C107.934 146.084 108.773 145.245 108.773 144.21C108.773 143.175 107.934 142.336 106.899 142.336Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.511788,
    filter: "url(#filter1_f_12439_55183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.688 188.139C126.888 188.139 135.967 179.057 135.967 167.853C135.967 156.65 126.888 147.567 115.688 147.567C104.488 147.567 95.4087 156.65 95.4087 167.853C95.4087 179.057 104.488 188.139 115.688 188.139Z",
    fill: "url(#paint4_linear_12439_55183)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M109.039 48.4887C117.301 48.4887 123.999 41.7887 123.999 33.5237C123.999 25.2587 117.301 18.5586 109.039 18.5586C100.776 18.5586 94.0786 25.2587 94.0786 33.5237C94.0786 41.7887 100.776 48.4887 109.039 48.4887Z",
    fill: "url(#paint5_linear_12439_55183)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M11.4388 38.0888C16.8399 38.0888 21.2183 33.7168 21.2183 28.3237C21.2183 22.9306 16.8399 18.5586 11.4388 18.5586C6.03764 18.5586 1.65918 22.9306 1.65918 28.3237C1.65918 33.7168 6.03764 38.0888 11.4388 38.0888Z",
    fill: "url(#paint6_linear_12439_55183)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0493 60.4609H77.3893C78.3441 60.4609 79.118 61.2352 79.118 62.1902C79.118 63.1453 78.3441 63.9195 77.3893 63.9195H40.0493C39.0945 63.9195 38.3206 63.1453 38.3206 62.1902C38.3206 61.2352 39.0945 60.4609 40.0493 60.4609Z",
    fill: "#4251DA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0493 68.3125H77.3893C78.3441 68.3125 79.118 69.0867 79.118 70.0418C79.118 70.9969 78.3441 71.7711 77.3893 71.7711H40.0493C39.0945 71.7711 38.3206 70.9969 38.3206 70.0418C38.3206 69.0867 39.0945 68.3125 40.0493 68.3125Z",
    fill: "#4251DA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0493 76.3535H77.3893C78.3441 76.3535 79.118 77.1277 79.118 78.0828C79.118 79.0379 78.3441 79.8121 77.3893 79.8121H40.0493C39.0945 79.8121 38.3206 79.0379 38.3206 78.0828C38.3206 77.1277 39.0945 76.3535 40.0493 76.3535Z",
    fill: "#4251DA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12439_55183",
    x: 0.459278,
    y: -3.24736,
    width: 146.989,
    height: 197.039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.661721
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5653
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.427451 0 0 0 0 0.537255 0 0 0 0.190587 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12439_55183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12439_55183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_12439_55183",
    x: 92.7618,
    y: 144.92,
    width: 45.8519,
    height: 45.866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.32344,
    result: "effect1_foregroundBlur_12439_55183"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12439_55183",
    x1: 73.8607,
    y1: 28.5361,
    x2: 73.8607,
    y2: 172.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6EAEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12439_55183",
    x1: 17.8668,
    y1: 189.873,
    x2: 34.2064,
    y2: 158.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12439_55183",
    x1: 90.7464,
    y1: 45.4613,
    x2: 24.5768,
    y2: 140.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12439_55183",
    x1: 105.641,
    y1: 17.0504,
    x2: -168.454,
    y2: 326.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4251DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12439_55183",
    x1: 94.686,
    y1: 198.075,
    x2: 123.164,
    y2: 143.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12439_55183",
    x1: 93.5455,
    y1: 55.8183,
    x2: 114.554,
    y2: 15.7605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12439_55183",
    x1: 1.31067,
    y1: 42.8715,
    x2: 15.0047,
    y2: 16.7122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmPhone);
export default __webpack_public_path__ + "static/media/confirm-phone.190dad5b74789384fe47bdcde2d50660.svg";
export { ForwardRef as ReactComponent };